import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  static classes = ["selected"]

  connect() {
    this.index = -1
  }

  next(event) {
    if (this.shouldIgnore(event)) return

    event.preventDefault()
    this.select(Math.min(this.index + 1, this.rowTargets.length - 1))
  }

  previous(event) {
    if (this.shouldIgnore(event)) return

    event.preventDefault()
    this.select(Math.max(this.index - 1, 0))
  }

  open(event) {
    if (this.shouldIgnore(event) || this.index < 0) return

    event.preventDefault()
    this.rowTargets[this.index].querySelector("a[data-edit]")?.click()
  }

  clear(event) {
    if (this.shouldIgnore(event) || this.index < 0) return

    event.preventDefault()
    this.rowTargets.forEach((row) => row.classList.remove(this.selectedClass))
    this.rowTargets[this.index].blur()
    this.index = -1
  }

  select(index) {
    if (index < 0 || index >= this.rowTargets.length) return

    this.rowTargets.forEach((row, i) => row.classList.toggle(this.selectedClass, i === index))
    this.index = index
    this.rowTargets[index].focus()
  }

  shouldIgnore(event) {
    if (document.querySelector("dialog[open]")) return true

    const tag = event.target.tagName
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || event.target.isContentEditable
  }
}
